import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {ClickEventHandler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';

/*
 * Props.
 */

interface CellButtonProps {
  avatar?: React.ReactNode;
  avatarSizePx?: number;
  onClick: ClickEventHandler;
  className?: string;
}

/*
 * Style.
 */

const StyledCellButtonContainerDiv = styled.div`
  width: 100%;
`;

const StyledChromelessButton = styled(ChromelessButton)`
  display: inline-flex;
  padding: 4px;
  border-radius: 16px;
  max-width: 100%;
  overflow: hidden;
  margin-left: -4px;

  &:hover {
    background: ${(p) => p.theme.alphas.gray10};
  }
`;

interface StyledAvatarContainerDivProps {
  $avatarSizePx?: number;
}
const StyledAvatarContainerDiv = styled.div<StyledAvatarContainerDivProps>`
  display: flex;
  margin-right: 8px;

  ${(p) =>
    p.$avatarSizePx &&
    css`
      flex: 0 0 ${p.$avatarSizePx}px;
    `}
`;

interface StyledCellButtonContentContainerDivProps {
  $avatarSizePx?: number;
  $hasAvatar: boolean;
}
const StyledCellButtonContentContainerDiv = styled.div<StyledCellButtonContentContainerDivProps>`
  flex: 1;

  ${(p) =>
    p.$hasAvatar &&
    css`
      max-width: calc(100% - ${p.$avatarSizePx ?? 0}px);
    `}
  ${(p) =>
    !p.$hasAvatar &&
    css`
      padding-left: 4px;
      padding-right: 4px;
    `}
`;

/*
 * Component.
 */

export const CellButton: FC<CellButtonProps> = (props) => {
  const {avatar, children, avatarSizePx, onClick, className} = props;

  return (
    <StyledCellButtonContainerDiv>
      <StyledChromelessButton onClick={onClick} className={className}>
        {avatar && <StyledAvatarContainerDiv $avatarSizePx={avatarSizePx}>{avatar}</StyledAvatarContainerDiv>}
        <StyledCellButtonContentContainerDiv $hasAvatar={Boolean(avatar)} $avatarSizePx={avatarSizePx}>
          {children}
        </StyledCellButtonContentContainerDiv>
      </StyledChromelessButton>
    </StyledCellButtonContainerDiv>
  );
};
